import {HRTemplateStep} from 'constants/CRISPRConstants';
import {HRTemplateDesignState} from 'molbio/crispr/hr-template/HRTemplateStore';
import * as net from 'util/Net';

export interface HRTemplateDesignServerData {
  sequence: string;
  pam: string;
  genome: string;
  guide: string;
  step: HRTemplateStep;
  armRegion: {start: number | null; end: number | null};
  savedVersions: Partial<Record<HRTemplateStep, number>>;
}

export function fetchForSequence(data: {sequenceId: string}): JQueryPromise<{
  hrTemplateDesign: HRTemplateDesignState | null;
}> {
  return net.postJSON({url: '/1/api/hr-template-designs/actions/check-exists', data});
}

export function create(data: HRTemplateDesignServerData): JQueryPromise<HRTemplateDesignState> {
  return net.postJSON({url: '/1/api/hr-template-designs/', data});
}

export function update(
  sequenceId: string,
  data: Partial<HRTemplateDesignServerData>
): JQueryPromise<HRTemplateDesignState> {
  return net.patchJSON({url: `/1/api/hr-template-designs/${sequenceId}`, data});
}
